export const PasswordChangeTranslationsDictionary =
{
    CurrentPassword: "Current Password",
    NewPassword: "New Password",
    RetypeNewPassword: "Retype New Password",
    Save: "Save",
    OK: "OK",
    ChangePassword: "Change password",
    EnterCurrentPassword: "Enter current password",
    EnterNewPassword: "Enter new password",
    ReenterNewPassword: "Re-enter new password",
    PleaseEnterYourCurrentPassword: "Please enter your current password.",
    PleaseEnterYourNewPassword: "Please enter your new password.",
    PleaseEnterYourMatchingPasswords: "Please enter matching passwords.",
    CommonPasswordsNotAllowed: "Common passwords are not allowed.",
    PasswordChangeSuccessfully: "Your password has been successfully changed.",
    NoChangePasswordWhenOffline: "You cannot change your password while offline.",
    YouAreUsingMyAdminAccount: "You are using a MyAdmin account. Passwords for accounts of this type must be changed through the MyAdmin portal.",
    ThisPasswordIsNotAllowed: "This password is not allowed.",
    IncorrectPasswordEntered: "You did not enter the correct current password. Please try again.",
    PasswordChangeError: "Password Change Error",
    ShortPasswordPhrase: "Password policy requires a minimum length of 8 characters."
};
let getTranslations = () => {
    let r: string[] = [];
    for (const prop in PasswordChangeTranslationsDictionary) {
        r.push(PasswordChangeTranslationsDictionary[prop]);
    }
    return r;
};

export const PasswordChangeTranslations = getTranslations();